import i18n from 'i18next';
import { Api, uploadMedia } from 'lib';

async function submit({ dispatch, data, handleClose, onPresetUnavailable, onSuccess }) {
  dispatch({
    type: 'LOADING_BUTTON',
    payload: 'navigator'
  });

  // let res = {};
  // if (data.media?.length) {
  //   const firstMedia =
  //     (data.media?.length && data.media[0].preview) ||
  //     data.metaData?.image ||
  //     (data.youtubeId && `https://img.youtube.com/vi/${data.youtubeId}/0.jpg`);

  //   const uploadedMedia = data.media?.length
  //     ? await Promise.all(data.media?.map((x, i) => uploadMedia(x, i)))
  //     : null;

  //   const shoutoutData = {
  //     media: uploadedMedia,
  //     comment: data.comment,
  //     entityId: data.entity?._id,
  //     eventId: data.eventObject?._id || undefined
  //   };

  //   res = await Api.post('/shoutouts/create', shoutoutData);
  // }

  const uploadedMedia = data.media?.length
    ? await Promise.all(data.media?.map((x, i) => uploadMedia(x, i)))
    : null;

  const shoutoutData = {
    media: uploadedMedia,
    comment: data.comment,
    entityId: data.entity?._id,
    eventId: data.eventObject?._id || undefined,
    // presetId lets the backend enforce the per-user preset cooldown
    ...(data.presetId && { presetId: data.presetId })
  };

  // silent so the coded preset errors (PRESET_COOLDOWN etc.) can be handled inline
  const res = await Api.post('/shoutouts/create', shoutoutData, undefined, { silent: true });

  dispatch({
    type: 'LOADING_BUTTON',
    payload: null
  });
  if (!res) return;

  // the preset went on cooldown between fetch and post — let the caller resync
  // the pills instead of closing the modal on a message that never posted
  if (res.code === 'PRESET_COOLDOWN' || res.code === 'PRESET_LIMIT') {
    dispatch({ type: 'HANDLE_RES', payload: { err: i18n.t('callToAction.presetUnavailable') } });
    onPresetUnavailable?.();
    return;
  }

  // any other failure: reproduce the global toast the non-silent path shows.
  // coded errors (e.g. 429 LIMIT_EXCEEDED) carry their user-facing text in
  // `message` instead of `err` — show that instead of the generic fallback
  if (res.err || res.status) {
    const backendMessage = res.err || (res.code && res.message);
    const errMessage =
      res.status >= 500 || !backendMessage
        ? i18n.t('error.somethingWentWrong') + '\n' + i18n.t('error.pleaseTryAgainLater')
        : backendMessage;
    dispatch({ type: 'HANDLE_RES', payload: { err: errMessage } });
    return;
  }

  dispatch({
    type: 'SENT_SHOUTOUT',
    payload: res
  });

  dispatch({
    type: 'ADD_SHOUTOUT',
    payload: res
  });

  // if(!data.media?.length) {
  //   dispatch({
  //     type: 'HANDLE_RES',
  //     payload: { res: i18n.t('shoutout.success') }
  //   })
  // }

  dispatch({
    type: 'HANDLE_RES',
    payload: { res: i18n.t('shoutout.success') }
  });

  // lets the surface that opened the modal pull in the new shout-out (e.g. the
  // profile refetches the channel feed) without the user refreshing
  onSuccess?.(res);

  handleClose();
}

export default submit;
